var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"DaOptional"}},[_c('div',{ref:"getDisciplineInfo",staticStyle:{"height":"500px"}}),_c('div',{ref:"getCombinationInfo",staticStyle:{"height":"400px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }